import Carousel from "@/design-system/carousel";
import type { ITelemetryButtonProps } from "@/design-system/telemetry-button";
import TelemetryButton from "@/design-system/telemetry-button";
import type { ITelemetryCustom } from "@/lib/telemetry";
import RoundTile from "@/src/common/RoundTile";
import { useViewportInfoContext } from "@/src/contexts";
import Text from "@Components/Text";
import * as stylex from "@stylexjs/stylex";

import { type QueryLgMin, type QueryXsMax, colors } from "./../../styles/tokens.stylex";
import type { IRoundTile } from "./RoundTile";

export interface IRoundList {
    id?: string;
    title?: string;
    moreLink?: ITelemetryButtonProps;
    numberElements?: number;
    itemsToShow?: number;
    initialData: IRoundTile[];
    carouselTelemetryCustom: ITelemetryCustom;
}

export default function RoundList(props: IRoundList) {
    const { isMobile, isMobileOrTablet } = useViewportInfoContext();

    const itemsToShow = props.itemsToShow || (isMobileOrTablet ? 5 : 7);

    // const items = props.initialData?.map((item) => (
    //     <BrandLink key={item.id} src={item.image.src} {...item} />
    // ));
    const items = props.initialData?.map((item) => <RoundTile key={item.id} {...item} />);

    return (
        <div id={props.id} {...stylex.props(styles.wrapper)}>
            {props.title && (
                <div {...stylex.props(styles.header)}>
                    <Text
                        textElement="h3"
                        fontStyle="h4"
                        fontWeight="bold"
                        dangerouslySetInnerHTML={{ __html: props.title }}
                        styleX={styles.title}
                    />
                    <TelemetryButton {...props.moreLink} styleX={[props.moreLink.styleX, styles.link]} />
                </div>
            )}
            <Carousel
                centerMode={isMobile}
                fullWidth={isMobile}
                showArrows={!isMobile}
                styleX={styles.carousel}
                itemStyleX={styles.carouselItem}
                itemsToShow={itemsToShow}
            >
                {items}
            </Carousel>
        </div>
    );
}

const xsMax: QueryXsMax = "@media (max-width: 759px)";
const lgMin: QueryLgMin = "@media (min-width: 1240px)";

const styles = stylex.create({
    wrapper: {
        marginBlock: "0",
        marginInline: "-10px",
    },
    title: { marginBlock: "0", marginInline: "10px" },
    header: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: {
            default: 40,
            [xsMax]: 20,
        },
    },
    link: {
        padding: 0,
        color: colors.fg_BrandNavy,
        fontSize: "0.875rem",
        fontWeight: 700,
        textTransform: "uppercase",
        marginRight: 0,
    },
    carousel: {
        gap: 0,

        scrollSnapType: {
            default: "x mandatory",
            [xsMax]: "none",
        },
        gridAutoColumns: {
            default: "20%",
            [lgMin]: "calc(100% / 7)",
            [xsMax]: "130px",
        },
        overscrollBehaviorX: "none",
    },
    carouselItem: {
        padding: {
            default: "0 10px",
            [xsMax]: "0 5px",
        },
    },
});
